import { useNavigate} from "react-router-dom";
import ForceSupersetLogout from "@components/nav/ForceSupersetLogout.component";




const LoginPage = () => {
    const navigate = useNavigate();

    // Check if they should be taken to a no-auth onboarding page or just the login page.


    return <>
        Login
    </>
    
}

export default LoginPage;
